import { setPreference } from "lib/api/currentUser";
import { SMART_EXPORT_PHONE_PUSH } from "lib/exportFormats";
import fetchJSON from "lib/fetchJSON";
import { Msg } from "lib/localization";
import React from "react";
import { connect } from "react-redux";
import { CreateAccountStep } from "../../CreateAccountStep";
import { s2dMessages } from "../../intlMessages";
import { Step2Container } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";

const deviceLabels = {
  iphone: "iPhone",
  android: "Android device",
};

export class MobileAppFlow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      appInstalled: !!props.skipInstallPrompt,
      pushSent: false,
      pushPending: false,
    };
  }

  onInstalledChange = (val) => {
    const appInstalled = val === "yes";
    this.setState({ appInstalled });
  };

  onSendPush = () => {
    const { routeId } = this.props;
    this.setState({ pushPending: true, pushSent: false });
    fetchJSON(`/routes/${routeId}/send_push_notification`, {}, { method: "POST" })
      .then(() => {
        this.setState({ pushPending: false, pushSent: true });
        setPreference("smart_export_state", SMART_EXPORT_PHONE_PUSH);
        setPreference("smart_export_show_phone_push_option", true);
      })
      .catch((e) => {
        this.setState({ pushError: true, pushPending: false, pushSent: false });
      });
  };

  render() {
    const { step, selectedDevice, skipInstallPrompt } = this.props;
    const { appInstalled, pushSent, pushPending, pushError } = this.state;
    const currentUser = window.rwgps && window.rwgps.config.currentUser;
    const deviceLabel = deviceLabels[selectedDevice];
    const title = (
      <Msg m={s2dMessages.sendTo} values={{ device: selectedDevice === "iphone" ? "iPhone" : "Android" }} />
    );
    if (!currentUser.id) {
      return <CreateAccountStep {...this.props} selectedDevice={selectedDevice} />;
    }
    // this offset is confusing and unfortunate.
    // Need to decouple UI step text from logical steps
    const virtualStep = skipInstallPrompt ? step + 1 : step;
    const stepCount = skipInstallPrompt ? 3 : 4;

    if (virtualStep === 2) {
      return (
        <Step2Container
          {...this.props}
          title={title}
          stepCount={stepCount}
          appInstalled={appInstalled}
          onInstalledChange={this.onInstalledChange}
          deviceLabel={deviceLabel}
        />
      );
    }
    if (virtualStep === 3) {
      return (
        <Step3
          {...this.props}
          title={title}
          stepCount={stepCount}
          appInstalled={appInstalled}
          onSendPush={this.onSendPush}
          pushSent={pushSent}
          pushPending={pushPending}
          pushError={pushError}
          deviceLabel={deviceLabel}
        />
      );
    }
    if (virtualStep === 4) {
      return <Step4 {...this.props} title={title} stepCount={stepCount} deviceLabel={deviceLabel} />;
    }
  }
}

const mapStateToProps = (state) => ({
  skipInstallPrompt: state.currentUser.preferences.get("S2D:skipInstallPrompt"),
});

const mapDispatchToProps = {
  setPreference: setPreference,
};

export const MobileAppFlowContainer = connect(mapStateToProps, mapDispatchToProps)(MobileAppFlow);
